import logoIcon from "../../assets/logoIcon.svg"

export default function LogoIcon() {
    return(
        <div className="logoIcon">
            <img id="logoIcon" src={logoIcon} alt="Smart Spending Logo Icon" />
        </div>
    )
}